<template>
    <el-dialog :visible.sync="visible" :title="title" width="80%" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-card shadow="never" class="aui-card--fill">
            <div class="mod-app__msupervise">
                <el-table v-loading="dataTaskListLoading" :data="dataTaskList" border  style="width: 100%;">
                    <el-table-column prop="ymd" label="年月" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="deviceCode" label="设备编码" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="fileSize" label="文件大小" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="status" label="状态" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status===0" size="small" type="success">待执行</el-tag>
                            <el-tag v-if="scope.row.status===1" size="small" type="success">下发通知</el-tag>
                            <el-tag v-if="scope.row.status===2" size="small" type="success">成功</el-tag>
                            <el-tag v-if="scope.row.status===3" size="small" type="success">已补偿其他设备</el-tag>
                            <el-tag v-if="scope.row.status===4" size="small" type="success">失败</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sendCount" label="下发次数" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="isCompensate" label="是否补偿" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status===0" size="small" type="success">正常</el-tag>
                            <el-tag v-if="scope.row.status===1" size="small" type="success">补偿</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="createDate" label="创建者" header-align="center" align="center"></el-table-column>
                </el-table>
                <el-pagination
                        :current-page="taskpage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="limit"
                        :total="tasktotal"
                        layout="total, sizes, prev, pager, next, jumper"
                        @size-change="pageSizeTaskChangeHandle"
                        @current-change="pageCurrentTaskChangeHandle">
                </el-pagination>
            </div>
        </el-card>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    import mixinViewModule from '@/mixins/view-module'
    export default {
        mixins: [mixinViewModule],
        data () {
            return {
                visible: false,
                title:'选择网盘文件派发任务列表',
                mixinViewModuleOptions: {
                    getDataListURL: '/dms/deviceStorageApp/page',
                    getDataListIsPage: true,
                    deleteURL: '/dms/deviceStorageApp',
                    deleteIsBatch: false,
                    activatedIsNeed: false,
                },
                dataTaskList: [],
                dataTaskListLoading: false,
                dataListSelections: [],
                taskpage: 1,                    // 当前页码
                tasklimit: 10,                  // 每页数
                tasktotal: 0,                   // 总条数
                dataTaskForm: {
                    addAppId: ''
                }
            }
        },
        methods: {
            init (id) {
                this.visible = true
                this.dataTaskForm.addAppId = id
                this.getDataTaskList();
            },
            // 分页, 每页条数
            pageSizeTaskChangeHandle (val) {
                this.taskpage = 1
                this.tasklimit = val
                this.getDataTaskList()
            },
            // 分页, 当前页
            pageCurrentTaskChangeHandle (val) {
                this.taskpage = val
                this.getDataTaskList()
            },
            getDataTaskList () {
                this.dataTaskListLoading = true
                this.$http.get('/dms/deviceStorageApp/getTaskList',
                    {
                        params: {
                            page: this.mixinViewModuleOptions.getDataListIsPage ? this.taskpage : null,
                            limit: this.mixinViewModuleOptions.getDataListIsPage ? this.tasklimit : null,
                            ...this.dataTaskForm
                        }
                    }
                ).then(({ data: res }) => {
                    this.dataTaskListLoading = false
                    if (res.code !== 0) {
                        this.dataTaskList = []
                        this.tasktotal = 0
                        return this.$message.error(res.msg)
                    }
                    this.dataTaskList = res.data.list
                    this.tasktotal = res.data.total
                }).catch(() => {
                    this.dataTaskListLoading = false
                })
            }
        }
    }
</script>

<style scoped>

</style>
